import React, { FC } from 'react';
import { Drawer as BaseDrawer, DrawerProps } from 'antd';
import cx from 'classnames';

import styles from './styles.module.css';

const Drawer: FC<DrawerProps> = ({ className, ...props }) => (
  <BaseDrawer className={cx(styles.root, className)} {...props} />
);

export default Drawer;
